import React from 'react';
import PropTypes from 'prop-types';

export default class ALargeInputField extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value || '',
			error: props.error || false,
		};

		this.bindHandles();
	}

	componentWillReceiveProps(props) {
		if (props.value !== this.state.value) {
			this.setState({ value: props.value });
		}
	}

	bindHandles() {
		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
	}

	handleOnChange(event) {
		const error = !this.isFieldValid({ value: event.target.value });

		if (this.props.onChange) {
			this.props.onChange(event.target.value, error);
		}

		this.setState({ value: event.target.value });
		this.waitSettingValidating({ error });
	}

	handleClick(event) {
		const error = !this.isFieldValid({ value: event.target.value });
		this.waitSettingValidating({ error });
	}

	waitSettingValidating({ error }) {
		clearTimeout(this.timer);

		this.timer = setTimeout(() => {
			this.setState({ error });
			clearTimeout(this.timer);
		}, 1000);
	}

	isFieldValid({ value }) {
		if (this.props.required && value.length === 0) {
			return false;
		}

		return true;
	}

	render() {
		let cName = this.props.className;

		if (this.state.error) {
			cName += `${cName} error`;
		}

		return (
			<textarea
				id={this.props.id}
				type={this.props.type}
				className={`a-field a-large-field ${cName}`}
				placeholder={this.props.placeholder}
				required={this.props.required}
				onChange={this.handleOnChange}
				onClick={this.handleClick}
				value={this.state.value}
			/>
		);
	}
}

ALargeInputField.propTypes = {
	id: PropTypes.string.isRequired,
	type: PropTypes.string,
	value: PropTypes.string,
	className: PropTypes.string,
	placeholder: PropTypes.string,
	required: PropTypes.bool,
	error: PropTypes.bool,
	onChange: PropTypes.func,
};

ALargeInputField.defaultProps = {
	type: 'text',
	className: '',
	placeholder: '',
	value: '',
	required: false,
	error: false,
	onChange: null,
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.large-input-field.js